<script setup lang="ts">
import { PropType } from 'vue'

const props = defineProps({
  width: {
    type: String,
    default: 'w-3/4'
  },
  possibleWidths: {
    type: Array as PropType<string[]>,
    default: () => []
  },
  height: {
    type: String,
    default: 'h-4'
  },
  color: {
    type: String,
    default: 'bg-gray-300'
  },
  borderRadius: {
    type: String,
    default: 'rounded-md'
  }
})

function getWidth() {
  if (!props.possibleWidths.length) {
    return props.width;
  }
  const idx = Math.floor(Math.random() * props.possibleWidths.length);
  return props.possibleWidths[idx];
}
</script>

<template>
  <div
    class="animate-pulse"
    :class="`${getWidth()} ${height} ${color} ${borderRadius}`"
    aria-busy="true"
    aria-hidden="true"
  ></div>
</template>

<style scoped>

</style>